(() => {
  const initializeToc = (section) => {
    const content = section.querySelector('[data-sss-article-content]');

    if (!content) return;

    const headings = Array.from(content.querySelectorAll('h2, h3')).filter(
      (heading) => heading.textContent.trim().length > 0
    );

    if (headings.length === 0) return;

    const usedIds = new Set(
      Array.from(document.querySelectorAll('[id]'))
        .map((element) => element.id)
        .filter(Boolean)
    );

    headings.forEach((heading, index) => {
      if (heading.id) return;

      const baseId =
        heading.textContent
          .trim()
          .toLowerCase()
          .normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '') || `section-${index + 1}`;

      let uniqueId = baseId;
      let suffix = 2;

      while (usedIds.has(uniqueId)) {
        uniqueId = `${baseId}-${suffix}`;
        suffix += 1;
      }

      heading.id = uniqueId;
      usedIds.add(uniqueId);
    });

    section.querySelectorAll('[data-sss-toc-list]').forEach((list) => {
      const fragment = document.createDocumentFragment();

      headings.forEach((heading) => {
        const item = document.createElement('li');
        const link = document.createElement('a');

        item.className = `sss-article-toc__item sss-article-toc__item--${heading.tagName.toLowerCase()}`;
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        fragment.appendChild(item);
      });

      list.replaceChildren(fragment);
    });

    section.querySelectorAll('[data-sss-toc]').forEach((toc) => {
      toc.hidden = false;
    });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-sss-article-section]').forEach(initializeToc);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
